// hooks/useBranchForm.ts
import { useRef, useState } from "react";
import { BranchFormData } from "../types/branch";

const initialFormData: BranchFormData = {
  Branchname: "",
  branchopeningdate: "",
  inputValue: "",
  address1: "",
  street: "",
  selectedCountry: "",
  selectedState: "",
  selectedCity: "",
  Pincode: "",
};

export const useBranchForm = () => {
  const [formData, setFormData] = useState<BranchFormData>({ ...initialFormData });
  const [doberror, setDobError] = useState(false);
  const [error, setError] = useState("");

  // refs for focus
  const refs = {
    branchopeningdateref: useRef<HTMLInputElement>(null),
    addressline1: useRef<HTMLInputElement>(null),
    streetnames: useRef<HTMLInputElement>(null),
    Countryref: useRef<HTMLInputElement>(null),
    Stateref: useRef<HTMLInputElement>(null),
    Cityref: useRef<HTMLInputElement>(null),
    pincoderef: useRef<HTMLInputElement>(null),
    setDobError,
  };

  // update form with partial data
  const updateFormData = (updates: Partial<BranchFormData>) => setFormData((prev) => ({ ...prev, ...updates }));

  // DOB change handler
  const handleDobChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    updateFormData({ branchopeningdate: value, inputValue: value });
    setDobError(!/^\d{2}-\d{2}-\d{4}$/.test(value));
  };

  // Pincode handler
  const handlePincodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // only digits
    updateFormData({ Pincode: value });
    setError(value && value.length !== 6 ? "Pincode must be 6 digits" : "");
  };

  // Branch name keypress (example: block Enter)
  const handleBranchnamesKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") e.preventDefault();
  };

  // Move to next field on Enter
  const createKeyPressHandler = (nextRef: React.RefObject<HTMLInputElement>) => (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && nextRef.current) nextRef.current.focus();
  };

  const resetForm = () => {
    setFormData({ ...initialFormData });
    setDobError(false);
    setError("");
  };

  return {
    formData,
    doberror,
    error,
    refs,
    updateFormData,
    handleDobChange,
    handlePincodeChange,
    handleBranchnamesKeyPress,
    createKeyPressHandler,
    resetForm,
    setDobError,
    setError,
  };
};
